import { DataGrid } from "@mui/x-data-grid";
import { useParsed } from "@refinedev/core";
import { useDataGrid } from "@refinedev/mui";
import { rsvpCols } from "tables/rsvpCols";
import { useBranch } from "../../../provider/BranchProvider";
import { EventRsvp } from "types/event";

export default function EventRsvps() {
  const { id: eventId } = useParsed();
  const branch = useBranch();

  const { dataGridProps } = useDataGrid<EventRsvp>({
    resource: "events/rsvps",
    filters: {
      permanent: [{ field: "eventId", operator: "eq", value: eventId }],
    },
  });

  return (
    <DataGrid
      {...dataGridProps}
      columns={rsvpCols(branch)}
      autoHeight
      isRowSelectable={() => false}
    />
  );
}
